import type { ReactNode } from 'react'

/**
 * Fila de filtros de la lista de conversaciones. Envuelve: todos a la vista.
 *
 * Hasta el 28-set-2026 era una sola línea deslizable con un degradado en el
 * borde derecho como única pista de que había más. Se había elegido para no
 * gastar alto: envolver cuesta una segunda línea, unos 30 px, y la lista pierde
 * una fracción de conversación visible.
 *
 * El COE lo reportó igual —«se está desvaneciendo a la derecha»—, y tenía
 * razón en lo que importa: el filtro que se desvanece es el que nadie toca, y
 * «Documentos» quedaba justo ahí. Con «Completos» son hasta cinco, así que
 * deslizar escondía dos. Un filtro escondido no filtra; 30 px de alto son más
 * baratos que eso.
 */
export default function FilaFiltros({ children }: { children: ReactNode }) {
  return <div className="mt-2.5 flex flex-wrap gap-1.5">{children}</div>
}
